import {type TranslationObject} from '@colonist/i18n'
import {HTTPStatus} from './ErrorEnums.ts'
import {ErrorDefault} from './Errors.ts'
import {SharedStrings} from '@colonist/types'

export namespace ErrorsMatchmaking {

    export class MatchmakingDisabled extends ErrorDefault {
        constructor() {
            const title: TranslationObject = {key: 'strings:popups.errors.matchmakingError.title'}
            const message: TranslationObject = {key: 'strings:popups.errors.matchmakingError.disabled'}
            const httpStatus = HTTPStatus.ServiceUnavailable
            super(title, message, httpStatus)
        }
    }

    export class FinishWatchingAd extends ErrorDefault {
        constructor() {
            const title: TranslationObject = {key: 'strings:popups.errors.matchmakingError.title'}
            const message: TranslationObject = {key: 'strings:popups.errors.matchmakingError.finishWatchingAd'}
            const httpStatus = HTTPStatus.Forbidden
            super(title, message, httpStatus)
        }
    }

    export class AlreadySearchingForMatch extends ErrorDefault {
        constructor() {
            const title: TranslationObject = {key: 'strings:popups.errors.matchmakingError.title'}
            const message: TranslationObject = {key: 'strings:popups.errors.matchmakingError.alreadySearchingForMatch'}
            const httpStatus = HTTPStatus.Conflict
            super(title, message, httpStatus)
        }
    }

    export class InternalServerError extends ErrorDefault {
        constructor() {
            const title: TranslationObject = {key: 'strings:popups.errors.matchmakingError.title'}
            const message: TranslationObject = {
                key: 'strings:popups.errors.matchmakingError.internalServerError',
                options: {
                    email: SharedStrings.SUPPORT_EMAIL,
                },
            }
            const httpStatus = HTTPStatus.InternalServerError
            super(title, message, httpStatus)
        }
    }

    export class InvalidRequest extends ErrorDefault {
        constructor() {
            const title: TranslationObject = {key: 'strings:popups.errors.matchmakingError.title'}
            const message: TranslationObject = {key: 'strings:popups.errors.matchmakingError.invalidRequest'}
            const httpStatus = HTTPStatus.BadRequest
            super(title, message, httpStatus)
        }
    }

    export class ConnectedToMultipleGames extends ErrorDefault {
        constructor() {
            const title: TranslationObject = {key: 'strings:popups.errors.matchmakingError.title'}
            const message: TranslationObject = {key: 'strings:popups.errors.matchmakingError.connectedToMultipleGames'}
            const httpStatus = HTTPStatus.Conflict
            super(title, message, httpStatus)
        }
    }

    export class RankedLocked extends ErrorDefault {
        constructor(gamesPlayed: number, gameRequired: number) {
            const title: TranslationObject = {key: 'strings:popups.errors.matchmakingInfo.title'}
            const message: TranslationObject = {
                key: 'strings:popups.errors.matchmakingInfo.playMoreToUnlockRanked',
                options: {
                    finishedGames: gamesPlayed,
                    totalRequiredGames: gameRequired,
                    gamesNeeded: gameRequired - gamesPlayed,
                },
            }
            const httpStatus = HTTPStatus.ServiceUnavailable
            super(title, message, httpStatus)
        }
    }

    export class ShuffleLocked extends ErrorDefault {
        constructor(gamesPlayed: number, gameRequired: number) {
            const title: TranslationObject = {key: 'strings:popups.errors.matchmakingInfo.title'}
            const message: TranslationObject = {
                key: 'strings:popups.errors.matchmakingInfo.playMoreToUnlockShuffle',
                options: {
                    finishedGames: gamesPlayed,
                    totalRequiredGames: gameRequired,
                    gamesNeeded: gameRequired - gamesPlayed,
                },
            }
            const httpStatus = HTTPStatus.ServiceUnavailable
            super(title, message, httpStatus)
        }
    }

    export class ServerUpdating extends ErrorDefault {
        constructor() {
            const title: TranslationObject = {key: 'strings:popups.errors.matchmakingError.title'}
            const message: TranslationObject = {
                key: 'strings:colonistCommon.serverStatus.serverUpdating',
                options: {
                    discordLink: SharedStrings.DISCORD_CHANNEL,
                },
            }
            const httpStatus = HTTPStatus.ServiceUnavailable
            super(title, message, httpStatus)
        }
    }

    export class AlreadyPlayingRankedGame extends ErrorDefault {
        constructor() {
            const title: TranslationObject = {key: 'strings:popups.errors.matchmakingError.title'}
            const message: TranslationObject = {key: 'strings:popups.errors.matchmakingError.alreadyPlayingRankedGame'}
            const httpStatus = HTTPStatus.Conflict
            super(title, message, httpStatus)
        }
    }

    export class InvalidRankedMode extends ErrorDefault {
        constructor() {
            const title: TranslationObject = {key: 'strings:popups.errors.matchmakingError.title'}
            const message: TranslationObject = {key: 'strings:popups.errors.matchmakingError.invalidRankedMode'}
            const httpStatus = HTTPStatus.BadRequest
            super(title, message, httpStatus)
        }
    }

    export class QueueUpdating extends ErrorDefault {
        constructor() {
            const title: TranslationObject = {key: 'strings:popups.errors.matchmakingError.queueUpdating.title'}
            const message: TranslationObject = {key: 'strings:popups.errors.matchmakingError.queueUpdating.body'}
            const httpStatus = HTTPStatus.ServiceUnavailable
            super(title, message, httpStatus)
        }
    }

    export class NoFreeGamesRemaining extends ErrorDefault {
        constructor() {
            const title: TranslationObject = {key: 'strings:popups.errors.matchmakingError.noFreeGamesRemaining.title'}
            const message: TranslationObject = {key: 'strings:popups.errors.matchmakingError.noFreeGamesRemaining.body'}
            const httpStatus = HTTPStatus.Forbidden
            super(title, message, httpStatus)
        }
    }
}
